
import { authTypes } from '../auth/types'

import { Comment, CommentsType } from 'src/ducks/comments/types'
import { CommentsActions, commentsTypes } from './types'

const initialState: CommentsType = {
  start: '',
  limit: '',
  total: '',
  items: [],
}

const reducer = (state = initialState, action: CommentsActions): CommentsType => {
  const { type, payload } = action
  switch (type) {
    case authTypes.LOGIN_REQUEST: { return initialState }
    case authTypes.LOGOUT_REQUEST: { return initialState }

    case commentsTypes.SET_COMMENTS: {
      return {
        ...state,
        start: (payload as unknown as CommentsType).start,
        limit: (payload as unknown as CommentsType).limit,
        items: (payload as unknown as CommentsType).items,
        total: (payload as unknown as CommentsType).total
      }
    }

    case commentsTypes.SET_COMMENT: {
      return {
        ...state,
        items: [
          payload as unknown as Comment,
          ...state.items
        ]
      }
    }
    default:
      return state
  }
}

export default reducer
